/**
 * V1.2 scope H — "Viser N af M {noun}" count strip used above list views.
 *
 * When `shown === total`, renders the shorter form "Viser N {noun}"
 * (hides the "af M" suffix). Handles Danish plural via explicit singular
 * + plural nouns (plurals are irregular enough that we don't try to
 * auto-derive them).
 */
export function ResultCount({
  shown,
  total,
  singularNoun,
  pluralNoun,
}: {
  shown: number;
  total: number;
  singularNoun: string;
  pluralNoun: string;
}) {
  const noun = shown === 1 ? singularNoun : pluralNoun;
  const body = shown === total ? `Viser ${shown} ${noun}` : `Viser ${shown} af ${total} ${noun}`;
  return (
    <div className="text-meta text-ink-2 tabular-nums" role="status">
      {body}
    </div>
  );
}
